import React, { useEffect, useState } from "react";
import handleFloating from "../../HOCs/handleFloating";
import styles from "./googleAds.scss";
import { GoogleAdConfig, destroyAdSlot, initializeAdSlot } from "../../services";
import { Icon } from "antd";
import { useSelector } from "react-redux";
import { selectProfileLoading, selectUserInfo } from "../../routes/Auth/auth.ducks";
import { usePlaceholderHeightChange } from "./hooks/usePlaceholderHeightChange";

export interface GoogleAdProps {
  className?: string;
  isFloat?: boolean;
  floatingClassName?: string;
  scrollingLock?: boolean;
  config: GoogleAdConfig;
  noTopMargin?: boolean;
  noBottomMargin?: boolean;
  placeholderHeight?: number;
  adLoadCallback?: (adId: string) => void;
}

const GoogleAdComponent = (props: GoogleAdProps) => {
  const {
    className,
    isFloat,
    floatingClassName,
    scrollingLock,
    config,
    noTopMargin,
    noBottomMargin,
    placeholderHeight,
    adLoadCallback
  } = props;

  const {
    wrapperRef,
    wrapperHeight,
    adLoaded,
    adRef,
  } = usePlaceholderHeightChange(placeholderHeight, config, adLoadCallback)

  // close icon visibbility
  const [isCloseVisible, setIsCloseVisible] = useState(true);

  const isStickyAd = config.id === "googleAds.M_sticky_all" || config.id === "googleAds.D_sticky_all";

  //@ts-ignore
  const wrapClassName = `${(isFloat && scrollingLock && floatingClassName) ||
    ""} ${className || ""}`;


  useEffect(() => {
    initializeAdSlot(config);

    return () => {
      destroyAdSlot(config);
    };
  }, []);


  const handleAdClose = () => {
    destroyAdSlot(config);
    setIsCloseVisible(false)
  }



  return (
    <div
      ref={wrapperRef}
      style={{ height: placeholderHeight ? wrapperHeight : undefined }}
      className={`
          ${styles.googleAds}
          ${wrapClassName}
          ${noTopMargin ? styles.noTopMargin : ""}
          ${noBottomMargin ? styles.noBottomMargin : ""}
          ${adLoaded ? styles.loaded : ""}
          ${isStickyAd ? styles.stickyAd : ""}
          `}
    >
      {isStickyAd && isCloseVisible && adLoaded && (
        <span onClick={handleAdClose} className={styles.close}>
          <Icon type="close" style={{ "color": "#fff", "fontSize": "12px" }} />
        </span>
      )}
      {/* Placeholder stays mounted and fades out as the ad fades in */}
      {Boolean(placeholderHeight) && (
        <div
          className={styles.placeholder}
          style={{ minHeight: placeholderHeight }}
        >
          <div style={{ minHeight: placeholderHeight }}>
            <span>OGLAS</span>
          </div>
        </div>
      )}
      <div id={config.id} ref={adRef} className={styles.adSlot} />
    </div>
  );
}



function GoogleAd(props: GoogleAdProps) {
  const userInfo = useSelector(selectUserInfo);
  const profileLoading = useSelector(selectProfileLoading);

  const userHasIndexPremium = userInfo && userInfo.hasIndexPremium;

  if (profileLoading || userHasIndexPremium) {
    return null;
  }


  return (
    <GoogleAdComponent {...props} />
  );


}

GoogleAd.defaultProps = {
  isFloat: false,
  scrollingLock: false,
  noTopMargin: false,
  noBottomMargin: false,
};

export default handleFloating(React.memo(GoogleAd));



// WEBPACK FOOTER //
// ./src/components/GoogleAd/index.tsx